import { subMonths } from 'date-fns'
import * as actionTypes from 'redux/actions'

const initialState = {
  filterType: 'brand',
  startDate: subMonths(new Date(), 1),
  endDate: new Date()
}

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ANALYTICS_DATA: {
      return {
        ...state,
        ...action.payload
      }
    }
    case actionTypes.SET_MAP_BOUNDS: {
      return {
        ...state,
        mapBounds: action.payload
      }
    }
    case actionTypes.CHANGE_FILTER_TYPE: {
      return { ...state, filterType: action.payload }
    }
    case actionTypes.CHANGE_SELECTED_DATE: {
      return {
        ...state,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate
      }
    }
    default: {
      return state
    }
  }
}

export default analyticsReducer
